/**
 * Created by robert.lavoie on 4/27/17.
 */

import {
  Image,
  ButtonLink
} from './';

export interface SiteColumn {
  readonly type: string;
  readonly html?: string;
  readonly headerHtml?: string;
  readonly videoUrl?: string;
  readonly image?: Image;
  backgroundImage?: Image;
  backgroundColor?: string;
  buttonLink?: ButtonLink;
};

export const VIDEO_PATTERN_VIMEO: RegExp = /(?:http?s?:\/\/)?(?:www\.)?(?:\/\/)?(?:vimeo\.com)\/?(.+)/;
export const VIDEO_PATTERN_YOUTUBE: RegExp = /(?:http?s?:\/\/)?(?:www\.)?(?:\/\/)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/;

export const INITIAL_SITE_COLUMN_STATE: SiteColumn = {
  type: undefined
};

export const INITIAL_SITE_COLUMN_TEXT_STATE: SiteColumn = {
  type: 'text',
  // tslint:disable-next-line:max-line-length
  html: '<h3><span style="color: rgb(0, 130, 194);">Headline</span></h3><p>Lorem ipsum dolor sit amet, ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>'
};

export const INITIAL_SITE_COLUMN_VIDEO_STATE: SiteColumn = {
  type: 'video',
  videoUrl: undefined
};

export const INITIAL_SITE_COLUMN_IMAGE_STATE: SiteColumn = {
  type: 'image',
  image: { url: '/assets/images/image-placeholder.svg', altText: null }
};

export const INITIAL_SITE_COLUMN_HTML_STATE: SiteColumn = {
  type: 'html',
  html: 'Insert HTML here',
};
